module.exports = __webpack_public_path__ + "img/献花.a336517a.png";